var map = {
	"./404.svg": 88616,
	"./address-line.svg": 45959,
	"./address-name.svg": 19244,
	"./address-phone.svg": 68327,
	"./balance.svg": 28508,
	"./benefits.svg": 85932,
	"./bug.svg": 86302,
	"./chart.svg": 17376,
	"./clipboard.svg": 87970,
	"./component.svg": 34245,
	"./dashboard.svg": 89356,
	"./documentation.svg": 63238,
	"./download.svg": 70008,
	"./drag.svg": 17974,
	"./edit.svg": 28796,
	"./education.svg": 6138,
	"./email.svg": 10256,
	"./example.svg": 50050,
	"./excel.svg": 29649,
	"./exit-fullscreen.svg": 86098,
	"./export.svg": 91978,
	"./eye-open.svg": 65880,
	"./eye.svg": 93399,
	"./facebook.svg": 7212,
	"./form.svg": 34890,
	"./fullscreen.svg": 5315,
	"./guide.svg": 75968,
	"./ic_down.svg": 49703,
	"./ic_search.svg": 76075,
	"./ic_up.svg": 31960,
	"./icon-delete.svg": 34981,
	"./icon-ic_screenshot.svg": 51007,
	"./icon.svg": 21363,
	"./icon_add.svg": 36835,
	"./icon_error.svg": 59732,
	"./icon_face.svg": 75721,
	"./international.svg": 55348,
	"./inventory.svg": 59852,
	"./language.svg": 33486,
	"./link.svg": 19960,
	"./list.svg": 74448,
	"./logo-mini.svg": 1819,
	"./logo.svg": 10365,
	"./logo1.svg": 886,
	"./logout.svg": 65130,
	"./message.svg": 13677,
	"./method.svg": 92595,
	"./money.svg": 50652,
	"./nested.svg": 34753,
	"./note.svg": 29956,
	"./password.svg": 16891,
	"./pdf.svg": 11394,
	"./people.svg": 777,
	"./peoples.svg": 22568,
	"./qq.svg": 36058,
	"./record.svg": 18071,
	"./search.svg": 85876,
	"./setting.svg": 41092,
	"./shopcart.svg": 13462,
	"./shopping.svg": 83500,
	"./size.svg": 67827,
	"./skill.svg": 52783,
	"./star.svg": 53864,
	"./subtract.svg": 38839,
	"./tab.svg": 23269,
	"./table.svg": 87436,
	"./theme.svg": 31127,
	"./tree-table.svg": 25395,
	"./tree.svg": 64400,
	"./triangle.svg": 84076,
	"./user.svg": 46889,
	"./wechat.svg": 44474,
	"./zip.svg": 33781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80256;